import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCalculatorContext } from '../contexts';
import { filterNonEmptyArrays } from '../utils/filterNonEmptyArrays';
var deleteItem = function deleteItem(productId, idx) {
  return function (oldValue) {
    var oldArrayValue = oldValue[productId !== null && productId !== void 0 ? productId : 0];
    if (!oldArrayValue) {
      return oldValue;
    }
    oldArrayValue.splice(idx !== null && idx !== void 0 ? idx : 0, 1);
    var newValue = _objectSpread(_objectSpread({}, oldValue), {}, _defineProperty({}, productId, oldArrayValue));
    return _objectSpread({}, filterNonEmptyArrays(newValue));
  };
};
export function useProductDelete() {
  var _useCalculatorContext = useCalculatorContext(),
    setSelectedProduct = _useCalculatorContext.setSelectedProduct,
    selectedProduct = _useCalculatorContext.selectedProduct,
    products = _useCalculatorContext.products,
    setProducts = _useCalculatorContext.setProducts,
    onProductDelete = _useCalculatorContext.actions.onProductDelete;
  return function (productId, idx) {
    setProducts(deleteItem(productId, idx));
    onProductDelete === null || onProductDelete === void 0 ? void 0 : onProductDelete(productId);
    if ((selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.id) === productId && (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.idx) === idx) {
      var newProductId = Object.keys(products).find(function (productId) {
        return products[productId].length > 0;
      });
      if (newProductId) {
        setSelectedProduct({
          id: newProductId,
          idx: 0
        });
      } else {
        setSelectedProduct(null);
      }
    }
  };
}